import {get, post} from './request'

export default {

    getReportFields: (success, failure) => get(
        'api/company/report-fields', success, failure
    ),
    getReportFieldCatalogue: (success, failure) => get(
        'api/company/report-fields/catalogue', success, failure
    ),
    postReportFields: (success, failure, payload) => post(
        'api/company/report-fields', payload, success, failure
    )
}
